import React, {useEffect, useRef, useState} from "react";
import {Button, Space, Row, Col, message} from "antd";
import MedicineSearchItem from "./components/MedicineSearchItem/MedicineSearchItem";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalContent from "./components/ModalContent/ModalContent";
import {catalogService} from "api";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {tabKeys} from "types/enums";
import {
  getAllListDilate,
  getListLichsuTraThuocAPI,
} from "redux/reducer/nurseOut";
const MedicineSearch = props => {
  const dispatch = useAppDispatch();
  const {idPhieu} = props;
  const modalRef = useRef<any>();
  const modalChildRef = useRef<any>();
  // const [listDilate, setListDilate] = useState<any[]>();
  const lichSuTra = useAppSelector(state => state.nurseOut.listLichSuTra);
  const activeTab = useAppSelector(state => state.common.activeTab);
  // const dilate = data => {
  //   setListDilate([data, ...listDilate]);
  // };
  // useEffect(() => {
  //   console.log(listDilate);
  // }, [listDilate]);
  useEffect(() => {
    if (activeTab == tabKeys.NURSE_OUT.DETAIL_PATIENT) {
      dispatch(getListLichsuTraThuocAPI(idPhieu));
      // getListLichsuTraThuoc();
    }
  }, [idPhieu, activeTab]);
  useEffect(() => {
    dispatch(getAllListDilate());
  }, []);

  return (
    <div className="medicine-search">
      <Space direction="vertical" style={{width: "100%"}}>
        {lichSuTra && (
          <>
            {lichSuTra.map((e, index) => (
              <MedicineSearchItem key={index} data={e}></MedicineSearchItem>
            ))}
          </>
        )}
        <Row justify={"end"}>
          <Button
            type="primary"
            onClick={() => {
              modalRef.current?.openModal();
              modalChildRef?.current?.resetFields();
            }}
          >
            Tra thuốc
          </Button>
        </Row>
        {/* {detailPhieu?.traThuoc != 1 && (
          
        )} */}
      </Space>
      <ModalCustom draggable width={1000} ref={modalRef} title="Tra thuốc">
        <ModalContent ref={modalChildRef}></ModalContent>
      </ModalCustom>
    </div>
  );
};
export default MedicineSearch;
